import { SCORE_CARD_SCHEMA } from 'utils/staticData'
import { formatParamDate } from 'utils/util'

export default {
  data() {
    return {
      searchSchema: [
        {
          label: '评分卡类型',
          type: 'select',
          itemName: 'typeCard',
          // selectList: SCORE_CARD_SCHEMA.map(item => {
          //   return { value: item.value, text: item.label }
          // }),
          selectList: [],
          allowClear: true,
        },
        {
          label: '运行时间',
          type: 'rangePicker',
          itemName: 'dateRange',
          format: 'YYYY-MM-DD',
          allowClear: true,
        },
        {
          label: '记录编号',
          type: 'input',
          itemName: 'id',
          allowClear: true,
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '评分卡名称',
          width: 180,
          dataIndex: 'scoreTypeName',
        },
        {
          title: '财报时间',
          width: 100,
          dataIndex: 'reportTime',
        },
        {
          title: '系统评分结果',
          width: 120,
          dataIndex: 'totalScore',
        },
        {
          title: '内部评级',
          width: 120,
          dataIndex: 'levelStr',
        },
        {
          title: '人工调整结果',
          width: 120,
          dataIndex: 'manualLevel',
        },
        {
          title: '人工调整原因',
          width: 120,
          dataIndex: 'remark',
        },
        {
          title: '运行时间',
          width: 150,
          dataIndex: 'createTime',
        },
        {
          title: '操作人',
          width: 120,
          dataIndex: 'operator',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 280,
          fixed: 'right',
        },
      ],
      UPDATE_MODAL_SCHEMA: {
        levelStr: {
          label: '内部评级',
          type: 'text',
        },
        manualLevel: {
          label: '调整后评分',
          type: 'select',
          optionList: [
            { label: 'AAA', value: 1 },
            { label: 'AA+', value: 2 },
            { label: 'AA', value: 3 },
            { label: 'AA-', value: 4 },
            { label: 'A+', value: 5 },
            { label: 'A', value: 6 },
            { label: 'A-', value: 7 },
            { label: 'BBB', value: 8 },
            { label: 'BB', value: 9 },
            { label: 'B', value: 10 },
          ],
          rules: [{ required: true, message: '请输入调整后的评分' }],
        },
        remark: {
          label: '备注',
          slotName: 'remark',
          rules: [{ required: true, message: '请输入备注' }],
        },
      },
      updateSourceData: {
        levelStr: 0,
        manualLevel: '',
        remark: '',
      },
      defaultColXs: 24,
      defaultColSm: 24,
      defaultColMd: 24,
      defaultColLg: 24,
      defaultColXl: 24,
      labelCol: {
        sm: { span: 6 },
        md: { span: 6 },
        lg: { span: 6 },
      },
      wrapperCol: {
        sm: { span: 16 },
        md: { span: 16 },
        lg: { span: 16 },
      },
      cardList: SCORE_CARD_SCHEMA,
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      data = formatParamDate(data, data.dateRange)
      delete data.dateRange
      this.searchForm = data
      this.pageData.current = 1
      this._getTableData(data)
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData(this.searchForm)
    },
  },
}
